import { useEffect,useState } from "react";
import { toast } from "../../../utils/notify";
import ApiLoader from "../../ui/ApiLoader";
import {
  fetchSettings,
  updateSettings,
} from "../../../services/axios/AuthApis/DashboardApis";

const Settings = ({ activeTab }) => {

  const [settings, setSettings] = useState({
    auto_scan: true,
    realtime_monitoring: true,
    scan_frequency: "daily",
    email_alert: true,
    sms_alert: false,
    slack_alert: true,
    organization_name: "HabileSec",
    admin_email: "admin@habilesec.com",
  });

  const [savingSettings, setSavingSettings] = useState(false);

  const [settingsLoading, setSettingsLoading] = useState(true);

  const handleSettingsChange = (e) => {
    const { name, value, type, checked } = e.target;

    setSettings({
      ...settings,
      [name]: type === "checkbox" ? checked : value,
    });
  };

 const saveSettings = async () => {
   try {
     setSavingSettings(true);

     await updateSettings({
       scan_interval: settings.scan_frequency,
       email_notifications: settings.email_alert,
       default_cloud: settings.cloud_provider,
     });

     toast.success("Settings updated successfully");
   } catch (err) {
     toast.error("Settings update failed");
   } finally {
     setSavingSettings(false);
   }
 };
 
 const loadSettings = async () => {
   try {
     setSettingsLoading(true);

     const response = await fetchSettings();

     setSettings({
       ...settings,
       scan_frequency: response.scan_interval || "24 Hours",
       email_alert: response.email_notifications,
       cloud_provider: response.default_cloud,
     });
   } catch (err) {
     toast.error("Failed to load settings");
   } finally {
     setSettingsLoading(false);
   }
 };

  useEffect(() => {
    if (activeTab === "settings") {
      loadSettings();
    }
  }, [activeTab]);

  if (settingsLoading) {
    return (
      <ApiLoader
        variant="spinner"
        label="Loading Settings..."
        className="py-20"
      />
    );
  }
  return (
    <>
      {activeTab === "settings" && (
        <>
        <h2 className="text-2xl font-bold mb-6">
  Settings
</h2>

<div className="space-y-6">

  {/* Scan Settings */}
  <div className="bg-white rounded-xl shadow p-6">

    <h3 className="text-xl font-bold mb-5">
      Scan Settings
    </h3>

    <div className="space-y-4">

      <div className="flex justify-between items-center">
        <span>Automatic Scan</span>

        <input
          type="checkbox"
          name="auto_scan"
          checked={settings.auto_scan}
          onChange={handleSettingsChange}
          className="w-5 h-5"
        />
      </div>

      <div className="flex justify-between items-center">
        <span>Real Time Monitoring</span>

        <input
          type="checkbox"
          name="realtime_monitoring"
          checked={settings.realtime_monitoring}
          onChange={handleSettingsChange}
          className="w-5 h-5"
        />
      </div>

      <div>
        <label className="block mb-2 font-medium">
          Scan Frequency
        </label>

        <select
          name="scan_frequency"
          value={settings.scan_frequency}
          onChange={handleSettingsChange}
          className="w-full border rounded-lg p-3"
        >
          <option value="hourly">Every Hour</option>
          <option value="daily">Daily</option>
          <option value="weekly">Weekly</option>
        </select>
      </div>

    </div>

  </div>

  {/* Notification Settings */}
  <div className="bg-white rounded-xl shadow p-6">

    <h3 className="text-xl font-bold mb-5">
      Notification Settings
    </h3>

    <div className="space-y-4">

      <div className="flex justify-between">
        <span>Email Alert</span>

        <input
          type="checkbox"
          name="email_alert"
          checked={settings.email_alert}
          onChange={handleSettingsChange}
          className="w-5 h-5"
        />
      </div>

      <div className="flex justify-between">
        <span>SMS Alert</span>

        <input
          type="checkbox"
          name="sms_alert"
          checked={settings.sms_alert}
          onChange={handleSettingsChange}
          className="w-5 h-5"
        />
      </div>

      <div className="flex justify-between">
        <span>Slack Alert</span>

        <input
          type="checkbox"
          name="slack_alert"
          checked={settings.slack_alert}
          onChange={handleSettingsChange}
          className="w-5 h-5"
        />
      </div>

    </div>

  </div>
    {/* Account Settings */}
  <div className="bg-white rounded-xl shadow p-6">

    <h3 className="text-xl font-bold mb-5">
      Account Settings
    </h3>

    <div className="grid md:grid-cols-2 gap-5">

      <div>
        <label>Organization Name</label>

        <input
          type="text"
          name="organization_name"
          value={settings.organization_name}
          onChange={handleSettingsChange}
          className="w-full border rounded-lg p-3 mt-2"
        />
      </div>

      <div>
        <label>Admin Email</label>

        <input
          type="email"
          name="admin_email"
          value={settings.admin_email}
          onChange={handleSettingsChange}
          className="w-full border rounded-lg p-3 mt-2"
        />
      </div>

    </div>

    <button
      onClick={saveSettings}
      disabled={savingSettings}
      className="mt-6 bg-blue-600 text-white px-6 py-3 rounded-lg"
    >
      {savingSettings ? "Saving..." : "Save Settings"}
    </button>

  </div>

</div>

        </>
      )}
    </>
  );
};

export default Settings;